// extracted by mini-css-extract-plugin
export default {"create":"CommentThreadFull-module__create--RVJx3","hasMoreScrollContent":"CommentThreadFull-module__hasMoreScrollContent--Ig5ua"};